export default {
  index: [
    {
      path: '/teaVip',
      component: resolve => require(['./tea_vipIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/vip/_router.js